import React from "react";
//useState
import { useState,useEffect } from "react";
import {editExpenseMoneyDetails} from "../../Redux/Actions/ExpenseActions";
//dispatch
import { useDispatch, useSelector } from "react-redux";
import {toast} from "react-toastify";


const ExpenseDetailProducts = (props) => {

  const { expense, loading } = props;
  const dispatch = useDispatch();


  const [expenseTotalPrice, setExpenseTotalPrice] = useState(0);
  const [expensePaidAmount ,setExpensePaidAmount] = useState(0);
  const [expenseDueAmount, setExpenseDueAmount] = useState(0);


  useEffect(() => {
    setExpenseTotalPrice(expense.expenseTotalPrice);
    setExpensePaidAmount(expense.expensePaidAmount);
    setExpenseDueAmount(expense.expenseDueAmount);
    }, [expense]);

  if (!loading) {
    // Calculate Price
    const addDecimals = (num) => {
      return (Math.round(num * 100) / 100).toFixed(2);
    };

    expense.itemsPrice = addDecimals(
      expense.expenseItems.reduce((acc, item) => acc + item.price * item.qty, 0)
    );
  }

  const handleUpdateOfExpense = () => {
      console.log(expenseTotalPrice,expensePaidAmount,expenseDueAmount);
      if (parseFloat(expenseTotalPrice) === parseFloat(expensePaidAmount)+ parseFloat(expenseDueAmount) ) {
          dispatch(editExpenseMoneyDetails(expense, expenseTotalPrice, expensePaidAmount, expenseDueAmount));
      }
      else{
        toast.error("Total Price is not equal to Paid Amount + Due Amount");
      }
  }



  return (

    <table className="table bexpense table-lg">
      <thead>
        <tr>
          <th style={{ width: "30%" }}>Bought Item | Paid Person</th>
          <th style={{ width: "10%" }}>Unit </th>
          <th style={{ width: "20%" }}>Unit Price</th>
          <th style={{ width: "20%" }}>Quantity</th>
          <th style={{ width: "20%" }} className="text-end">
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        {/* if expense.expenseItems exists*/}
        {expense.expenseItems && expense.expenseItems[0].title && (
            <>
                {expense.expenseItems.map((item,index) => (

                              <tr key={index}>
                                <td>
                                    <div className="info">{item.title}</div>
                                </td>
                                <td>{item.unit} </td>
                                <td>{item.priceOfItem} TND </td>
                                <td>{item.quantity} </td>
                                <td className="text-end">{item.totalPriceOfBoughtItems}</td>
                              </tr>
                            ))}
            </>
        )}

        {expense.paidSuppliers && expense.paidSuppliers[0].supplierName && (

            <>
                {expense.paidSuppliers.map((supplier,index) => (
                    <tr key={index}>
                      <td>
                        <div className="info">{supplier.supplierName}</div>
                      </td>
                      <td>- </td>
                      <td>-</td>
                      <td>- </td>
                      <td className="text-end">{supplier.paidAmount}</td>
                    </tr>
                    ))}
            </>
        )}


        <tr>
          <td colSpan="5">
            <article className="float-end">
              <dl className="dlist">
                <dt>Subtotal:</dt> <dd>{expense.expenseTotalPrice} TND</dd>
              </dl>
              <dl className="dlist">
                <dt>Paid Amount:</dt> <dd>{expense.expensePaidAmount} TND</dd>
              </dl>
              <dl className="dlist">
                <dt>Due Amount:</dt> <dd>{expense.expenseDueAmount} TND</dd>
              </dl>

              <dl className="dlist">
                <dt className="text-muted">Status:</dt>
                <dd>
                  {expense.expenseTotalPrice=== expense.expensePaidAmount ? (
                    <span className="badge rounded-pill alert alert-success text-success">
                      Paid
                    </span>
                  ) : (
                    <span className="badge rounded-pill alert alert-danger text-danger">
                      Not Paid
                    </span>
                  )}
                </dd>
              </dl>
            </article>
          </td>
        </tr>
      {/* 3 inlines inputs for changing total price , paidAmount and dueAmount*/}
      <tr>

        <td colSpan="5">
            <article className="float-end">
<dl className="dlist">
    <dt>Change Total Price:</dt> <dd>
  <input type="text" className="form-control" placeholder="Change Total Price"
  value={expenseTotalPrice}
         onChange={(e) => {
              setExpenseTotalPrice(e.target.value);
         }
            }
  /></dd>
    </dl>
    <dl className="dlist">
    <dt>Change Paid Amount:</dt> <dd>
      <input type="text" className="form-control" placeholder="Change Paid Amount"
      value={expensePaidAmount}
             onChange={(e) => {
                setExpensePaidAmount(e.target.value);
                }
             }
             onBlur={
                () => {
                    setExpenseDueAmount(expenseTotalPrice - expensePaidAmount);
                }
             }
      /></dd>
    </dl>
    <dl className="dlist">
    <dt>Change Due Amount:</dt> <dd>
      <input type="text" className="form-control" placeholder="Change Due Amount"
      value={expenseDueAmount}
             onChange={(e) => {
                setExpenseDueAmount(e.target.value);
                }
             }
             onBlur={() => {
                setExpensePaidAmount(expenseTotalPrice - expenseDueAmount);
                }
                }

      /></dd>
    </dl>
              {/*  button to submit changes*/}
              <dl className="dlist">
                <button className="btn btn-primary m-2"
                onClick={handleUpdateOfExpense}


                >Update</button>
              </dl>
    </article>
        </td>



      </tr>


      </tbody>
    </table>
  );
};

export default ExpenseDetailProducts;
